import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import React, { useEffect, useRef, useState } from "react"
import { Backdrop, Box, Button, Dialog, Modal, Tooltip } from "@mui/material"
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { DeviceWidths } from "../../shared/src/types/Miscs"
import { useStore } from "../../contexts/store"
import { Op_editUserData } from "../../shared/src/types/Ops"
import getReactElementRef from '@mui/utils/getReactElementRef'

// selected text associated with the interaction
const Minibutton = (props:any) => {
  const { children, onClick } = props
  const sx = {
    userSelect:'none',
    display: 'inline-block',
    padding: '0px 4px',
    border: '1px solid #0004',
    borderRadius: '4px',
    backgroundColor:'#fff',
    ':hover': {
      cursor:'pointer',
      border: '1px solid #000a',
    }
  }
  return <Box onClick={onClick} sx={{...sx, ...props.sx}}>
    {children}
  </Box>
}

export default Minibutton
